import { useEffect, useState } from 'react';

const PARTNER_CHROME_ALLOWANCE = 160;
const MINIMUM_WORKSPACE_HEIGHT = 320;

export function getEmbeddedWorkspaceHeight(windowLike) {
  const frameHeight = Number(windowLike.innerHeight) || MINIMUM_WORKSPACE_HEIGHT;
  const browserHeight = Number(windowLike.outerHeight) || frameHeight;
  return Math.max(
    MINIMUM_WORKSPACE_HEIGHT,
    Math.min(frameHeight, browserHeight - PARTNER_CHROME_ALLOWANCE),
  );
}

export function useEmbeddedWorkspaceHeight(isEmbedded) {
  const [height, setHeight] = useState(() => (isEmbedded ? getEmbeddedWorkspaceHeight(window) : null));

  useEffect(() => {
    const documentRoot = document.documentElement;
    if (!isEmbedded) {
      setHeight(null);
      documentRoot.classList.remove('aiker-embedded-page');
      documentRoot.style.removeProperty('--aiker-workspace-height');
      return undefined;
    }
    const update = () => {
      const nextHeight = getEmbeddedWorkspaceHeight(window);
      documentRoot.style.setProperty('--aiker-workspace-height', `${nextHeight}px`);
      setHeight((currentHeight) => (currentHeight === nextHeight ? currentHeight : nextHeight));
    };
    documentRoot.classList.add('aiker-embedded-page');
    update();
    window.addEventListener('resize', update);
    const intervalId = window.setInterval(update, 500);
    return () => {
      window.removeEventListener('resize', update);
      window.clearInterval(intervalId);
      documentRoot.classList.remove('aiker-embedded-page');
      documentRoot.style.removeProperty('--aiker-workspace-height');
    };
  }, [isEmbedded]);

  return height;
}
